import React, { useState } from 'react';
import Footer from './Footer';

const inputClass = "border border-gray-300 dark:border-white/15 p-2 rounded bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-white focus:border-gray-900 dark:focus:border-white transition-colors";

const BookingForm = () => {
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [eventTime, setEventTime] = useState('');
  const [message, setMessage] = useState('');
  const [eventType, setEventType] = useState('');
  const [letter, setLetter] = useState(null);
  const [status, setStatus] = useState('pending'); // Default status as "Pending"

  const handleLetterChange = (e) => {
    setLetter(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('names', fullName);
    formData.append('phone', phone);
    formData.append('email', email);
    formData.append('event_date', eventDate);
    formData.append('event_time', eventTime);
    formData.append('message', message);
    formData.append('event_type', eventType);
    formData.append('status', status);
    formData.append('letter', letter); // Append the file

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/booking_invite/upload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to upload booking');
      }

      alert('Booking uploaded successfully! Please wait for review and approval from Elayone Music');
      setFullName('');
      setPhone('');
      setEmail('');
      setEventDate('');
      setEventTime('');
      setMessage('');
      setEventType('');
      setLetter(null);
    } catch (error) {
      console.error(error);
      alert('Error: ' + error.message);
    }
  };

  return (
    <div>
    <div className="flex items-center justify-center min-h-screen pt-[120px] pb-16 bg-white dark:bg-black transition-colors duration-300">
      <div className="bg-white dark:bg-[#111010] border border-gray-200 dark:border-white/10 text-gray-900 dark:text-white p-8 rounded-lg max-w-md w-full mx-4 shadow-sm">
        <h2 className="text-3xl text-center mb-4 font-greatvibes">Invite Us</h2>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Full Names *</span>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              className={inputClass}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Phone Number *</span>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className={inputClass}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Email Address *</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={inputClass}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Event Date *</span>
            <input
              type="date"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
              required
              className={inputClass}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Event Time *</span>
            <input
              type="time"
              value={eventTime}
              onChange={(e) => setEventTime(e.target.value)}
              required
              className={inputClass}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Additional Message *</span>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="4"
              placeholder='Ex: purpose of event, size of events, location...'
              className={`${inputClass} resize-none`}
            />
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Event Type *</span>
            <select
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
              required
              className={inputClass}
            >
              <option value="" disabled>Select Event Type </option>
              <option value="Prayer">Prayer</option>
              <option value="Overnight">Overnight</option>
              <option value="Evangelism">Evangelism</option>
              <option value="Open Event">Open Event</option>
              <option value="Concert">Concert</option>
              <option value="Others">Others</option>
            </select>
          </label>

          <label className="flex flex-col">
            <span className="mb-1 text-gray-600 dark:text-gray-300">Upload Letter *</span>
            <div className="flex items-center">
              <label className="bg-gray-100 dark:bg-white/10 py-2 px-4 rounded cursor-pointer hover:bg-gray-200 dark:hover:bg-white/15 transition-colors">
                <span className="text-gray-700 dark:text-gray-200 text-sm">Choose letter only (pdf) </span>
                <input
                  type="file"
                  accept="pdf/*"
                  onChange={handleLetterChange}
                  className="hidden"
                  required
                />
              </label>
              {letter && <span className="ml-2 text-gray-500 dark:text-gray-400 text-sm truncate">{letter.name}</span>}
            </div>
          </label>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-gray-900 dark:bg-white text-white dark:text-black text-sm font-medium py-2 px-5 rounded hover:bg-black dark:hover:bg-gray-200 transition-colors"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <Footer />

    </div>
  );
};

export default BookingForm;
